import * as React from "react";

import classnames from "classnames";

export default function DrawerMenu() {
  const classes = classnames("wib-drawer-menu", {
    "wib-drawer-menu-expanded": false
  });

  return (
    <div className={classes}>
      <ul className="list-unstyled"></ul>
    </div>
  );
}
